var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftSwipeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1335",
    "data-name": "Group 1335",
    transform: "translate(412 367) rotate(180)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_108",
    "data-name": "Ellipse 108",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(378 333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M4404.729,560.5l5.877,6.773,6.03-6.773",
    transform: "translate(-168.886 4760.682) rotate(-90)",
    fill: "none",
    stroke: "#07b4e8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftSwipeIcon);
export default __webpack_public_path__ + "static/media/leftSwipeIcon.11f0f36dfcdf17704c519f6f4c11c060.svg";
export { ForwardRef as ReactComponent };